import { useState, useEffect, useCallback } from 'react';
import { safeLocalStorage } from '@/utils/safeStorage';

const WELCOME_SHOWN_KEY = 'geniebot_welcome_shown';
const DONT_SHOW_KEY = 'geniebot_welcome_dont_show';

export const useWelcomeModal = () => {
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    const hasShown = safeLocalStorage.getItem(WELCOME_SHOWN_KEY);
    const dontShow = safeLocalStorage.getItem(DONT_SHOW_KEY);
    
    if (!hasShown && !dontShow) {
      setShowWelcome(true);
      safeLocalStorage.setItem(WELCOME_SHOWN_KEY, 'true');
    }
  }, []);

  const triggerWelcome = useCallback(() => {
    setShowWelcome(true);
  }, []);

  const resetWelcomeState = useCallback(() => {
    // Remove the "don't show again" flag so it shows on next visit
    safeLocalStorage.removeItem(DONT_SHOW_KEY);
    safeLocalStorage.removeItem(WELCOME_SHOWN_KEY);
  }, []);

  return {
    showWelcome,
    setShowWelcome,
    triggerWelcome,
    resetWelcomeState,
  };
};
